var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.334 4.99935V7.01601C18.334 8.33268 17.5007 9.16602 16.184 9.16602H13.334V3.34101C13.334 2.41601 14.0923 1.66602 15.0173 1.66602C15.9257 1.67435 16.759 2.04101 17.359 2.64101C17.959 3.24935 18.334 4.08268 18.334 4.99935Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66602 5.83268V17.4993C1.66602 18.191 2.44935 18.5827 2.99935 18.166L4.42435 17.0993C4.75768 16.8493 5.22435 16.8827 5.52435 17.1827L6.90768 18.5744C7.23268 18.8994 7.76602 18.8994 8.09102 18.5744L9.49102 17.1744C9.78268 16.8827 10.2493 16.8493 10.5743 17.0993L11.9993 18.166C12.5493 18.5744 13.3327 18.1827 13.3327 17.4993V3.33268C13.3327 2.41602 14.0827 1.66602 14.9993 1.66602H5.83268H4.99935C2.49935 1.66602 1.66602 3.15768 1.66602 4.99935V5.83268Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 10.8418H10",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 7.50781H10",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99609 10.834H5.00358",
    stroke: "#292D32",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99609 7.5H5.00358",
    stroke: "#292D32",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.c7c68ee1e8bcb0e25f6559bf15d40ebc.svg";
export { ForwardRef as ReactComponent };